/**
 * Zoom’s CommandChannel allows up to 512 characters per message.
 * We interpret this as a 2048-byte limit (512 × 4 bytes/char) to account
 * for UTF-8 encoding, where a single JS character can use up to 4 bytes.
 *
 * Reference:
 * > "The maximum size is 512 characters and the rate limit is 35 commands per second."
 * > https://developers.zoom.us/docs/video-sdk/web/command-channel/
 */
export const ZOOM_COMMAND_CHANNEL_MESSAGE_MAX_SIZE_BYTES = 2048;
